import { render, staticRenderFns } from "./ModificaQuestionario.vue?vue&type=template&id=72a50b3e&"
import script from "./ModificaQuestionario.vue?vue&type=script&lang=js&"
export * from "./ModificaQuestionario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports